import React, { useCallback } from "react";
import { styled } from "../stitches.config";
import { User, Viewport } from "../types";
import { motion, useMotionValue } from "framer-motion";
import {
  BOT_NAME,
  DEFAULT_GRID_RESOLUTION,
  DEFAULT_SPRING,
  ROOM_SERVICE_MAP_KEYS,
  ROOM_SERVICE_PRESENCE_KEYS,
} from "../consts";
import { usePresenceCallback } from "../roomservice/utils";
import { useMapWrapper } from "../roomservice/maps";

let borderWidth = 0;
export default function ViewportRect({
  isSelf,
  userId,
}: {
  isSelf: boolean;
  userId: string;
}) {
  const [userInfo] = useMapWrapper<User>(ROOM_SERVICE_MAP_KEYS.USER + userId);

  const x = useMotionValue(0);
  const y = useMotionValue(0);
  const w = useMotionValue(0);
  const h = useMotionValue(0);
  const onViewportPresence = useCallback(
    (msg: Record<string, Viewport>) => {
      if (!msg[userId]) {
        return;
      }

      x.set(msg[userId].position.x - borderWidth / 2);
      y.set(msg[userId].position.y - borderWidth / 2);
      w.set(msg[userId].size.width + borderWidth);
      h.set(msg[userId].size.height + borderWidth);
    },
    [x, y, w, h, userId]
  );

  usePresenceCallback(ROOM_SERVICE_PRESENCE_KEYS.VIEWPORT, onViewportPresence);

  if (!userInfo) return <></>;

  const position = {
    x: x,
    y: y,
  };
  const size = {
    width: w,
    height: h,
  };
  if (isSelf) return null;
  if (userInfo.name === BOT_NAME) return null;

  return (
    <ViewPortOutline
      className="viewport"
      key={userInfo.id}
      style={{
        borderColor: userInfo?.color?.replace("1)", "0.2)") || "transparent",
        ...position,
        ...size,
      }}
      transition={DEFAULT_SPRING}
    ></ViewPortOutline>
  );
}

export const ViewPortOutline = styled(motion.div, {
  position: "absolute",
  pointerEvents: "none",
  top: 0,
  left: 0,
  fontSize: "$3",
  borderWidth: DEFAULT_GRID_RESOLUTION,
  borderStyle: "solid",
});
